import { Component, Input, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { IssuesFilterSupplier, WorksheetReport, DownloadTypes, DocumentReport } from '@arpada/arp-lib-common-qupro';
import { PortalProveedorService, MessagesService, FileDownloadService } from '../../../services/api.services';
import { ActionsSharedData } from '../actions-header/actions.shared.data';

@Component({
  selector: 'app-descarga-hojas-trabajo',
  templateUrl: './descarga-hojas-trabajo.component.html',
  styleUrls: ['./descarga-hojas-trabajo.component.scss'],
})
export class DescargaHojasTrabajoComponent implements OnInit {

  @Input() idsFilterIssues: number[];
  @Input() filter: IssuesFilterSupplier; // son mis filtros y order de la lib
  @Input() selected: boolean;
  @Input() mode: string;
  @Input() sharedData: ActionsSharedData;

  worksheetReport: WorksheetReport = new WorksheetReport();

  private resolveDocumentDownload: (toResolve: boolean) => void;
  private rejectDocumentDownload: (toResolve: boolean) => void;
  private loadingWidget: HTMLIonLoadingElement = null;
  private readonly actionSheetPromiseExecutor =
        (resolveFun: (toResolve: boolean) => void, rejectFun: (toReject: boolean) => void) => {
            this.resolveDocumentDownload = resolveFun;
            this.rejectDocumentDownload = rejectFun;
        }

  constructor(private portalProveedorService: PortalProveedorService,
              private fileDownloadService: FileDownloadService,
              private messagesService: MessagesService,
              private loadingController: LoadingController) { }

  async ngOnInit() {
    this.worksheetReport.mode = this.mode;
    if (this.idsFilterIssues === undefined) {
      this.worksheetReport.csite_id = this.filter.csite_id;
      this.worksheetReport.supplier_partner_id = this.filter.supplier_partner_id;
      this.worksheetReport.filter = this.filter;
    } else {
      this.worksheetReport.csite_id = this.filter.csite_id;
      this.worksheetReport.supplier_partner_id = this.filter.supplier_partner_id;
      this.worksheetReport.filter = new IssuesFilterSupplier();
      this.worksheetReport.filter.setIds(this.idsFilterIssues);
    }
    this.loadingWidget = await this.loadingController.create({
      message: this.messagesService.getLoadingActionMessage(),
      duration: 0,
      backdropDismiss: false,
      showBackdrop: true,
    });
    this.closeLoading();
    this.loadingWidget.present();
  }

  excelDownload() {
    this.showLoading();
    const type = DownloadTypes.EXCEL;
    this.portalProveedorService.downloadWorksheet(this.worksheetReport, type).subscribe((docReport: DocumentReport) => {
      this.generateReport(docReport);
    });
  }

  pdfDownload() {
    this.showLoading();
    const type = DownloadTypes.PDF;
    this.portalProveedorService.downloadWorksheet(this.worksheetReport, type).subscribe((docReport: DocumentReport) => {
      this.generateReport(docReport);
    });
  }

  private generateReport(docReport: DocumentReport): Promise<boolean> {
    const loggerName = 'documento ' + docReport.document_id;
    this.fileDownloadService.completeDownloadAction(docReport.document_name, docReport.document_mime, docReport.document, loggerName)
    .then(() => {
        this.resolveDocumentDownload(true);
    }).catch(() => {
        this.resolveDocumentDownload(false);
    }).finally(() => {
        this.closeLoading();
    });
    return new Promise<boolean>(this.actionSheetPromiseExecutor);
  }

  private showLoading() {
    this.loadingWidget.hidden = false;
}

private closeLoading() {
    this.loadingWidget.hidden = true;
}

}
